import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vShow as _vShow } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = {
  key: 1,
  class: "intro"
}
const _hoisted_3 = {
  class: "title typeWriter",
  ref: "typeWriterText"
}
const _hoisted_4 = { class: "screenReader" }
const _hoisted_5 = { class: "originalText" }
const _hoisted_6 = { class: "grid" }
const _hoisted_7 = { class: "start-btn" }
const _hoisted_8 = ["action"]
const _hoisted_9 = { class: "question" }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "answers" }
const _hoisted_12 = ["id", "value"]
const _hoisted_13 = ["for"]
const _hoisted_14 = { class: "btns" }
const _hoisted_15 = { class: "continue-btn" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { class: "previous-btn" }
const _hoisted_18 = { class: "btns" }
const _hoisted_19 = { class: "continue-btn" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "previous-btn" }
const _hoisted_23 = ["value"]
const _hoisted_24 = {
  key: 1,
  class: "lottieFile"
}
const _hoisted_25 = { class: "factCard question" }
const _hoisted_26 = {
  key: 0,
  class: "info"
}
const _hoisted_27 = { class: "details" }
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  key: 1,
  class: "factTitle"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_IntroGrid = _resolveComponent("IntroGrid")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Question = _resolveComponent("Question")!
  const _component_Vue3Lottie = _resolveComponent("Vue3Lottie")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["surveyTool", { surveyPage: $setup.showSurvey }])
  }, [
    (!$setup.showSurvey)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_Navbar, { isLandingPage: true })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["container", { center: !$setup.showSurvey || $setup.showLoader }])
    }, [
      ($setup.showSurvey && !$setup.showLoader)
        ? (_openBlock(), _createBlock(_component_Navbar, {
            key: 0,
            isLandingPage: false
          }))
        : _createCommentVNode("", true),
      (!$setup.showSurvey)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("h1", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString($setup.survey?.surveyName), 1),
              _createElementVNode("span", _hoisted_5, _toDisplayString($setup.survey?.surveyName), 1),
              _cache[7] || (_cache[7] = _createElementVNode("span", {
                "aria-hidden": "true",
                class: "animate"
              }, null, -1))
            ], 512),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.survey?.introGrid, (introGrid, index) => {
                return (_openBlock(), _createBlock(_component_IntroGrid, {
                  key: index,
                  introGrid: introGrid
                }, null, 8, ["introGrid"]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => ($setup.startSurvey && $setup.startSurvey(...args)), ["prevent"]))
              }, [...(_cache[8] || (_cache[8] = [
                _createTextVNode(" Start ", -1),
                _createElementVNode("img", {
                  src: "/assets/images/icons/arrowRight-Primary.svg",
                  alt: ""
                }, null, -1)
              ]))])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(["survey", { loading: $setup.showLoader }])
          }, [
            ($setup.showLoader)
              ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["questions", { loading: $setup.showLoader }])
            }, [
              (!$setup.updateSurvey)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["progress", { updateSurvey: $setup.updateSurvey }])
                  }, _toDisplayString($setup.activeQuestionIndex + 2) + " OF " + _toDisplayString($setup.survey?.questions.length + 1), 3))
                : _createCommentVNode("", true),
              _createElementVNode("form", {
                method: "get",
                action: $setup.formAction,
                onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submitSurvey && $setup.submitSurvey(...args)), ["prevent"]))
              }, [
                _withDirectives(_createElementVNode("fieldset", {
                  class: _normalizeClass({ updateSurvey: $setup.updateSurvey })
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("h2", _hoisted_10, _toDisplayString($setup.survey?.routingQuestion), 1),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["answer-wrapper", { twoColumns: $setup.survey?.routingAnswers.length > 6 }])
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.survey?.routingAnswers, (answer, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(["answer radio", {
                        checked: $setup.selectedRoutingAnswer === index
                      }]),
                            key: index
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "radio",
                              name: "routing",
                              id: index,
                              value: index,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.selectedRoutingAnswer) = $event))
                            }, null, 8, _hoisted_12), [
                              [_vModelRadio, $setup.selectedRoutingAnswer]
                            ]),
                            _createElementVNode("label", { for: index }, _toDisplayString(answer.answerText), 9, _hoisted_13)
                          ], 2))
                        }), 128))
                      ], 2)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("button", {
                        disabled: $setup.selectedRoutingAnswer === null,
                        onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => ($setup.nextQuestion && $setup.nextQuestion(...args)), ["prevent"]))
                      }, [...(_cache[9] || (_cache[9] = [
                        _createTextVNode(" Continue ", -1),
                        _createElementVNode("img", {
                          src: "/assets/images/icons/arrowRight-White-Thin.svg",
                          alt: ""
                        }, null, -1)
                      ]))], 8, _hoisted_16)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("button", {
                        onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => ($setup.previousQuestion && $setup.previousQuestion(...args)), ["prevent"]))
                      }, [...(_cache[10] || (_cache[10] = [
                        _createElementVNode("img", {
                          src: "/assets/images/icons/arrowLeft-Charcoal.svg",
                          alt: ""
                        }, null, -1),
                        _createTextVNode("Previous ", -1)
                      ]))])
                    ])
                  ])
                ], 2), [
                  [_vShow, $setup.activeQuestionIndex === -1]
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.survey?.questions, (question, index) => {
                  return _withDirectives((_openBlock(), _createElementBlock("fieldset", {
                    class: _normalizeClass({ updateSurvey: $setup.updateSurvey }),
                    key: question.id
                  }, [
                    _createVNode(_component_Question, {
                      question: question,
                      onSelectedAnswers: 
                  selectedAnswers => $setup.updateQuestionsAnswered(question.id, selectedAnswers)
                
                    }, null, 8, ["question", "onSelectedAnswers"]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        ($setup.activeQuestionIndex !== $setup.survey?.questions.length - 1)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => ($setup.nextQuestion && $setup.nextQuestion(...args)), ["prevent"])),
                              disabled: $setup.isDisabled(question.id, question.isRequired)
                            }, [...(_cache[11] || (_cache[11] = [
                              _createTextVNode(" Continue ", -1),
                              _createElementVNode("img", {
                                src: "/assets/images/icons/arrowRight-White-Thin.svg",
                                alt: ""
                              }, null, -1)
                            ]))], 8, _hoisted_20))
                          : (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "submit",
                              disabled: $setup.isDisabled(question.id, question.isRequired)
                            }, [...(_cache[12] || (_cache[12] = [
                              _createTextVNode(" Discover how we can help you ", -1),
                              _createElementVNode("img", {
                                src: "/assets/images/icons/arrowRight-White-Thin.svg",
                                alt: ""
                              }, null, -1)
                            ]))], 8, _hoisted_21))
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _withDirectives(_createElementVNode("button", {
                          onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => ($setup.previousQuestion && $setup.previousQuestion(...args)), ["prevent"]))
                        }, [...(_cache[13] || (_cache[13] = [
                          _createElementVNode("img", {
                            src: "/assets/images/icons/arrowLeft-Charcoal.svg",
                            alt: ""
                          }, null, -1),
                          _createTextVNode(" Previous ", -1)
                        ]))], 512), [
                          [_vShow, $setup.activeQuestionIndex > -1]
                        ])
                      ])
                    ])
                  ], 2)), [
                    [_vShow, index === $setup.activeQuestionIndex && $setup.activeQuestionIndex >= 0]
                  ])
                }), 128)),
                _createElementVNode("input", {
                  type: "hidden",
                  name: "surveyId",
                  value: $setup.id
                }, null, 8, _hoisted_23)
              ], 40, _hoisted_8)
            ], 2)
          ], 2))
    ], 2),
    ($setup.showSurvey && !$setup.updateSurvey && !$setup.showLoader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          ($setup.isMobile())
            ? (_openBlock(), _createBlock(_component_Vue3Lottie, {
                key: 0,
                animationLink: `/assets/lottie/surveyTool/mobile-${$setup.activeQuestionIndex + 2}.json`,
                loop: false,
                height: "auto"
              }, null, 8, ["animationLink"]))
            : (_openBlock(), _createBlock(_component_Vue3Lottie, {
                key: 1,
                animationLink: `/assets/lottie/surveyTool/pc-long-${$setup.activeQuestionIndex + 2}.json`,
                loop: false,
                height: "auto"
              }, null, 8, ["animationLink"]))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_25, [
      ($setup.showSurvey && !$setup.showLoader)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              (!$setup.updateSurvey)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: `${$setup.factIconUrl}`,
                    alt: ""
                  }, null, 8, _hoisted_28))
                : _createCommentVNode("", true),
              (!$setup.updateSurvey)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_29, _toDisplayString($setup.factTitle), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}